import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "ne_cookie_notice_ok";

export default function CookieNotice() {
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(localStorage.getItem(KEY) !== "1"); }, []);
  if (!show) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  return (
    <div role="region" aria-label="Cookie notice" className="fixed z-[45] bottom-20 lg:bottom-6 left-4 right-4 lg:left-auto lg:right-6 lg:max-w-sm metal metal-edge border border-[var(--line)] p-5 chamfer-sm" data-testid="cookie-notice">
      <p className="text-sm text-[var(--grey)] leading-relaxed">
        We only use essential storage needed for this site to work. No advertising cookies. <Link to="/privacy" className="underline text-white" data-testid="cookie-privacy-link">Privacy &amp; cookies</Link>
      </p>
      <button type="button" onClick={close} className="mt-4 h-10 px-5 bg-white text-[var(--ink)] font-display font-extrabold uppercase tracking-[0.14em] text-sm hover:bg-[var(--grey)] transition-colors" data-testid="cookie-accept-btn">OK</button>
    </div>
  );
}
